import React from 'react';
import MainLayout from './layouts/main/MainLayout';
import SelectAll from './layouts/main/SelectAll';
import { Route, Routes } from "react-router-dom";
import Navbar from './layouts/Navbar'
import 'bootstrap/dist/css/bootstrap.min.css';
import Dtail from './layouts/main/Detail'
import MapPage from './layouts/main/MapPage'
import MapPage2 from './layouts/main/MapPage2';
import MapPage3 from './layouts/main/MapPage3';
import Login from './pages/auth/Login';
import PrivateRoute from './components/auth/PrivateRoute';

interface RouteType {
  type: string;
  name: string;
  key: string;
  route: string;
  component: React.ComponentType<any>;
  noCollapse: boolean;
  protected: boolean;
}

const allRoutes: RouteType[] = [
  {
    type: "none",
    name: "Login",
    key: "login",
    route: "/login",
    component: Login,
    noCollapse: true,
    protected: false,
  },
  {
    type: "none",
    name: "MainLayout",
    key: "main-layout",
    route: "/",
    component: MainLayout,
    noCollapse: true,
    protected: true,
  },
  {
    type: "none",
    name: "SelectAll",
    key: "select-all",
    route: "/selectall",
    component: SelectAll,
    noCollapse: true,
    protected: true,
  },
  {
    type: "none",
    name: "Dtail",
    key: "dtail",
    route: "/detail/:device/:prdId",
    component: Dtail,
    noCollapse: true,
    protected: true,
  },
  {
    type: "none",
    name: "Map",
    key: "map",
    route: "/map",
    component: MapPage,
    noCollapse: true,
    protected: true,
  },
  {
    type: "none",
    name: "Map",
    key: "map",
    route: "/map2",
    component: MapPage2,
    noCollapse: true,
    protected: true,
  },
  {
    type: "none",
    name: "Map",
    key: "map",
    route: "/map3",
    component: MapPage3,
    noCollapse: true,
    protected: true,
  },
];

const getRoutes: any = (allRoutes: RouteType[]) =>
  allRoutes.map((route: RouteType) => {
    if (route.protected) {
      return (
        <Route
          path={route.route}
          element={
            <PrivateRoute>
              <route.component />
            </PrivateRoute>
          }
          key={route.key}
        />
      );
    }
    return <Route path={route.route} element={<route.component />} key={route.key} />
  });

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        {getRoutes(allRoutes)}
      </Routes>
    </div>
  );
}

export default App;
